import { STORE_LAST_FILTERS_APPLIED, STORE_FILTER_OPTIONS } from '../types';

const initialState = {
  lastFiltersApplied: {
    reportType: 0,
    patientGroupItemCode: null,
    year: null,
    indicator: null,
  },
  filterCache: {
    patientsGroups: null,
    years: null,
    indicators: null,
  },
  lastCacheTime: null,
};

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
  case STORE_LAST_FILTERS_APPLIED:
    return {
      ...state,
      type: action.type,
      lastFiltersApplied: action.payload,
    };
  case STORE_FILTER_OPTIONS:
    return {
      ...state,
      type: action.type,
      filterCache: action.filterCache,
      lastCacheTime: action.lastCacheTime,
    };
  default:
    return state;
  }
};

export default filterReducer;
